import 'bootstrap';
import './main.scss';
import $ from 'jquery';
import ModalVideo from 'modal-video';
import objectFitImages from 'object-fit-images';

window.objectFitImages = objectFitImages;

window.jQuery = $;
window.$ = $;

const subPage = false;

const modalvideo = new ModalVideo('.js-modal-video', {
  channel: 'vimeo',
  api: true,
  autoplay: true,
  title: 'false'
});

$(document).ready(function () {
  if ($(window).width() < 768) {
    $('.plus').find('.dropdown-container').remove()
  }
})

objectFitImages();

// Add active class to current choices
$('.nav-item').hover(function () {
  var width = $(window).width()
  if (width > 768) {
    $(this).toggleClass('active').siblings().removeClass('active')
    $(this).find('.dropdown-container').toggleClass('show')
  }
})

// Add arrow to parent in menu if it has subitems
$('.dropdown-container')
  .parent()
  .addClass('plus');
$('.plus > a:first-of-type').append($('<span/>').addClass('chevron-nav'));

// subPage variable is set in navbar.php
// if (subPage) {
//   $('.dropdown-container')
//     .parent()
//     .removeAttr('href');
//   $('.dropdown-container')
//     .parent()
//     .addClass('plus');
//   $('.dropdown-container').remove();
// }

// Change text on click
$('.accordion-button').click(function () {
  if (
    $(this)
    .find('.accordion-button-inner')
    .html() === 'Read More'
  ) {
    $(this)
      .find('.accordion-button-inner')
      .html('Close');
  } else {
    $(this)
      .find('.accordion-button-inner')
      .html('Read More');
  }
});

$('.lipids-container').on('mouseenter mouseleave', function () {
  $(this)
    .find('.box-hover')
    .fadeToggle(100);
});

// Create wrapper for images in editor
$('p img').wrap("<div class='img-skew-wrapper'></div>");

// Disable main category on mobile
// $(window).resize(function () {
//   if ($(window).width() < 415) {
//     $('.dropdown-container').siblings('.nav-link').removeAttr('href');
//   }
// })

// $(document).ready(function () {
//   if ($(window).width() < 415) {
//     $('.dropdown-container').siblings('.nav-link').removeAttr('href');
//   }
// })

// Special code for Edge (scroll down in tracing)
